import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token'); // Get the token from local storage

  // If a token exists, the user is considered authenticated.
  // Render the protected content.
  if (token) {
    return children ? children : <Outlet />;
  }

  // If there is no token, redirect the user to the login page.
  return <Navigate to="/login" replace />;
};

export default PrivateRoute;